import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { mapKeys } from 'lodash-es';
import type { Agent, Location } from '../../types';

interface AgentState {
  agents: Record<number, Agent>;
  agentLocations: Location[];
}

const initialState: AgentState = {
  agents: {},
  agentLocations: [],
};

const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    setAgents(state, action: PayloadAction<Agent[]>) {
      state.agents = mapKeys(action.payload, 'id') as unknown as Record<number, Agent>;
    },
    setAgentLocations(state, action: PayloadAction<Location[]>) {
      state.agentLocations = action.payload;
    },
  },
});

export const { setAgents, setAgentLocations } = agentSlice.actions;
export default agentSlice.reducer;
